module.exports = __webpack_public_path__ + "assets/cbdc4b4110c25eb24716b24e7dc59107.svg";